import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { colors } from "../../assets/styles";

const fadeInAnimation = keyframes`${fadeIn}`;

export const Div = styled.div``;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const Address = styled.div`
  color: ${(props) =>
    props?.theme?.isDarkTheme
      ? colors?.textColorBlackFive
      : colors?.textColorBlackFor};
`;

export const Phone = styled.a`
  display: block;
  color: ${colors?.colorRed};

  :hover {
    color: ${colors?.colorRed};
  }
`;

export const MapRoute = styled.div`
  font-weight: 600;
  color: ${(props) =>
    props?.theme?.isDarkTheme
      ? colors?.textColorBlackFive
      : colors?.textColorBlackOne};
`;

export const MapBtn = styled.a`
  border-radius: 7px;
  border: 1px solid
    ${(props) => (props?.theme?.isDarkTheme ? colors?.colorDarkOne : "#e3e3e3")};
  box-shadow: 0 0 4px 1px
    ${(props) => (props?.theme?.isDarkTheme ? colors?.colorDarkOne : "#e3e3e3")};
`;
